export const UNKNOWN = '_unknown_';
export const EMPTY = '_empty_';
export const MIN_PASSWORD_LENGTH = 12;

// Constantes asociadas a informes
export const MAX_RUNNING_REPORTS_PER_USER = 3;
export const DEFAULT_ROWS_REPORT_FILE = 100000;
export const MAX_ROWS_REPORT_FILE = 1000000;
